<template>
<div
  class="hot-wrapper"
  :style="{height:showHeight}"
>
  <!-- <img
    v-if="pagePicFile"
    :src="require(`../../assets/img/newspaper/xlglrb/2020/08/17/A1/xlglrb20200817A1_b.jpg`)"
    usemap="#Map"
    ismap
    /> -->
    <!-- <img
    v-if="newspaperName"
    :src="`${imgUrl}/${newspaperName}/${newspaperName}/${outfilePath}/${pagePicFile}`"
    usemap="#Map"
    ismap
    /> -->
    <van-swipe
      :autoplay="false"
      :loop="false"
      :show-indicators="false"
      :stop-propagation="false"
      :touchable="true"
      ref="swiper"
      @change="onChange"
    >
      <van-swipe-item v-for="item in allPageList" :key="item.id">
        <img
          usemap="#Map"
          :src="`${imgUrl}/${item.accessName}/${item.accessName}/${item.outfilePath}/${item.pagePicFile}`"
          ref="hotspotImg"
          @load="onload"
          />
        <map name="Map" id="Map">
          <area
            shape="poly"
            v-for="itemArea in newsAreaList"
            :key="itemArea.id"
            :coords="itemArea.coords"
            :href="`#/content/${itemArea.id}/${item.accessName}/${newPageId}/${item.pageDate}`"
          />
        </map>
        <!-- <svg class="svg" xmlns="http://www.w3.org/2000/svg" :style="{height: imgHeight}">
          <polygon
            v-for="itemArea in newsAreaList"
            :key="itemArea.id"
            :points="itemArea.coords"
          />
        </svg> -->
      </van-swipe-item>
    </van-swipe>
</div>
</template>

<script>
import { computed, onBeforeUpdate, ref, onMounted, reactive } from 'vue'
import { useStore } from 'vuex'
export default {
  name: 'Hotspot',
  props: {
    pageInfo: Object,
    newspaper: String,
    pageNewsArea: Array,
    swiperIndex: String,
    defaultList: Array
  },
  setup (props, { emit }) {
    const imgUrl = process.env.VUE_APP_UPLOAD_URL
    const store = useStore()
    const newsPage = ref([])
    const swiper = ref()
    const newspaperName = ref()
    const outfilePath = ref()
    const pagePicFile = ref()
    const hotspotImg = ref()
    const svgHeight = ref()
    // const imgWidth = ref()
    const imgHeight = ref()
    // const svgWidth = ref()
    // const directoryId = ref('')
    // const defaultListArea = ref()
    const newPageId = ref('')
    const newPageNewsArea = ref([])
    const pageAreaArray = ref([])
    let temNewsAreaList = reactive()
    const newsAreaList = ref([])
    // const allArearList = ref([])
    const allPageList = computed(() => store.state.allPageList)

    const pageList = computed(() => store.state.pageList)
    const swiperIndex = computed(() => store.state.swiperIndex)
    const showHeight = ref()
    // const imgWidth = ref()
    // 图片加载完成后获取图片的高度
    const onload = () => {
      // const imgHeight = hotspotImg.value.offsetHeight
      // const imgWidth = hotspotImg.value.offsetWidth
    }
    onMounted(() => {
      window.fullHeight = document.documentElement.clientHeight
      showHeight.value = window.fullHeight - 45 - 54 - 6 + 'px'
    })
    onBeforeUpdate(() => {
      swiper.value.swipeTo(swiperIndex.value)
      pageAreaArray.value = []
      for (let i = 0; i < allPageList.value.length; i++) {
        pageAreaArray.value.push({
          pageId: allPageList.value[i].id,
          area: JSON.parse(allPageList.value[i].newsArea)
        })
        // debugger
      }
      onChange(swiperIndex.value)
    })
    // const onload = () => {
    //   svgHeight.value = hotspotImg.value.offsetHeight
    // }
    const onChange = (index) => {
      // store.dispatch('getSwiperIndex', index)
      emit('changeIndex', index)
      if (index < swiperIndex.value) {
        index = swiperIndex.value
      }
      for (let i = 0; i < allPageList.value.length; i++) {
        if (index === i) {
          store.dispatch('addPageListData', allPageList.value[i])
        }
      }
      if (pageAreaArray.value.length !== 0) {
        newPageNewsArea.value = pageAreaArray.value[index].area
        newPageId.value = pageAreaArray.value[index].pageId
        // debugger
      }
      if (newPageNewsArea.value !== undefined) {
        newsAreaList.value = []
        for (let i = 0; i < newPageNewsArea.value.length; i++) {
          const id = newPageNewsArea.value[i].ID
          const temporaryList = newPageNewsArea.value[i].COORDS.split(',')
          if (newspaperName.value === 'hljrb') {
            const countCoordsList = countRatio(temporaryList)
            temNewsAreaList = countCoordsList.join(',')
          } else {
            temporaryList.map((item, index) => {
              // temporaryList[index] = item * 1.12
              temporaryList[index] = parseInt(item * 1.12)
            })
            temNewsAreaList = temporaryList.join(',')
          }
          newsAreaList.value.push({
            id: id,
            coords: temNewsAreaList
          })
        }
        console.log(newsAreaList.value)
      }
    }
    // 重新计算坐标点的位置
    const countRatio = (arr) => {
      const itemList = ref([])
      var countRetio = ref()
      for (var j = 0, len = arr.length; j < len; j++) {
        if (j % 2 === 0) {
          countRetio.value = arr[j] * 0.17789
        } else {
          countRetio.value = arr[j] * 0.22233
        }
        itemList.value.push(countRetio.value.toFixed(0))
      }
      return itemList.value
    }
    return {
      swiper,
      allPageList,
      pageList,
      imgUrl,
      newsPage,
      newPageId,
      newspaperName,
      outfilePath,
      pagePicFile,
      newsAreaList,
      hotspotImg,
      showHeight,
      imgHeight,
      svgHeight,
      pageAreaArray,
      onChange,
      onload
    }
  }
}
</script>

<style lang="scss">
.hot-wrapper{
  margin-top: 6px;
  text-align:center;
  .svg{
    width: 100%;
    top: 0;
    left: 0;
    position: absolute;
    polygon{
      opacity: 0.3;
      fill: rgba(220,220,220,0);
      stroke: none;
      stroke-dasharray: 1;
    }
    polygon:hover{
      stroke: black;
      fill: #f68a8a;
    }
  }
}
img{
  width:100%;
}
</style>
